import React from "react";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";

const Card = ({ item }) => {
  return (
    <Container>
      <div className="row card-box">
      {item.map((Val) => {
        return(       
          <Col size={12} sm={6} md={4}>
            <div className="proj-imgbx">
              <img src={Val.imgUrl} />
              <div className="proj-txtx">
                <h4>{Val.category}</h4>
                <span>{Val.text}</span>
              </div>
            </div>
          </Col>              
        );
      })}
      </div>
    </Container>
  );
};

export default Card;